export enum SPACE_INVADERS_ATLAS_FRAMES {
  EXPLOSION_1 = 'explosion-1.png',
  EXPLOSION_2 = 'explosion-2.png',
  MISSILE = 'missile.png',
  SHIP = 'ship.png',
  NUMBER_DEFAULT = 'numbers/default.png',
  NUMBER_SYSTEM_SELECTED = 'numbers/system-selected.png',
  NUMBER_SYSTEM_SELECTED_TRANSITION = 'numbers/system-selected-transition.png',
  NUMBER_PLAYER_SELECTED = 'numbers/player-selected.png',
  NUMBER_HIT = 'numbers/match.png',
  NUMBER_HIT_TRANSITION = 'numbers/match-transition.png',
  NUMBER_GLOW = 'numbers/glow.png',
}

export enum SPACE_INVADERS_TEXTURE_KEYS {
  ATLAS = 'SPACE_INVADERS_ATLAS',
  NUMBER_DEFAULT = 'SPACE_INVADERS_NUMBER_DEFAULT',
  NUMBER_SYSTEM_SELECTED = 'SPACE_INVADERS_NUMBER_SYSTEM_SELECTED',
  NUMBER_SYSTEM_SELECTED_TRANSITION = 'SPACE_INVADERS_NUMBER_SYSTEM_SELECTED_TRANSITION',
  NUMBER_PLAYER_SELECTED = 'SPACE_INVADERS_NUMBER_PLAYER_SELECTED',
  NUMBER_HIT = 'SPACE_INVADERS_NUMBER_HIT',
  NUMBER_HIT_TRANSITION = 'SPACE_INVADERS_NUMBER_HIT_TRANSITION',
}
